import { useHistory, useLocation } from 'react-router'
import { AppContact } from '../components/AppContact'
import logo from '../eye-mask.svg'
import appScreen1 from '../assets/app_screen1.png'
import { motion } from "framer-motion";
import { Transitions } from "../transitions/pageTransitions";

export const LandingMain = () => {

    const history = useHistory()
    const location = useLocation()

    function openLogIn() {

        history.push('/stapp/login')

    }

    function openRegister() {

        if (('Notification' in window))
            history.push('/stapp/register')
        else
            linkBrowser('/stapp/register')

    }

    function linkBrowser(path = location.pathname) {
        var aTag = document.getElementById('browser_linker') as any
        aTag.href = location.pathname
        aTag.click()
    }

    function NavButtons() {

        if (!navigator.userAgent.includes("Instagram"))
            return (<div className='flex-column' >
                <button className='button-styled button-login-next'
                    style={{ marginBottom: 10 }}
                    onClick={openLogIn} >
                    Log In <span className="material-icons-outlined">
                        login
                    </span></button>
                <button className='button-styled button-register-next' onClick={openRegister} >
                    Register <span className="material-icons-outlined">
                        person_outline
                    </span></button>
            </div>)
        else
            return (
                <div className='button-styled button-browser-next' onClick={() => linkBrowser()} >
                    Open in Browser
                    <span className="material-icons-round">
                        language
                    </span>
                </div>

            )

    }

    return (
        <motion.div className='absolute' style={{ height: '100%', width:'100%', overflow: 'scroll' }}
            initial="initial"
            animate="in"
            exit="out"
            variants={Transitions.pageVariants}
            transition={Transitions.pageTransition}
        >
            <div className='landing relative' >
                <section className=' flex-column relative' style={{ height: '100vh' }}  >
                    <div style={{ position: 'absolute', right: 0, backgroundColor: 'purple', width: 10, height: '100%' }} ></div>
                    <img src={logo} alt="" style={{ position: 'absolute', width: 400, height: 200, left: -197 }} />
                    <i className="material-icons"
                        style={{ fontSize: 100, zIndex: 10, position: 'absolute', top: 180, left: -50 }} >mic</i>
                    <div style={{ position: 'absolute', left: 10, bottom: 30, width: '100%' }} >
                        <h1 style={{ color: 'purple', fontSize: 30 }} >Say To Me</h1>
                        <h4>The <span style={{ color: 'purple' }} >Private</span> Dateship App</h4>
                        <h4>Where the <span style={{ color: 'red' }} >Real</span> Crowd will be!</h4>
                        <div className='flex-column' style={{ alignItems: 'flex-end', marginRight: 30, marginTop: 20 }} >
                            <NavButtons />
                        </div>
                    </div>
                </section><section className='flex-column center-both' style={{ width: '100%', backgroundColor: 'purple', color: 'white', textAlign: 'center' }} >
                    <h3>Open, but Private</h3>
                </section>
                <section className='flex-column center-both' style={{ color: 'purple' }} >
                    <img src={appScreen1} style={{ width: '100%' }} alt="" />
                </section>
                <section className='flex-column center-both' style={{ fontFamily: 'Glory' }} >
                    <h3>Verified individuals, not by poses but by taste</h3>
                    <img src={logo} alt="" style={{ width: '100px', height: '60px' }} />
                    <AppContact />
                </section>

            </div>
        </motion.div>
    )
}